import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SmokeEffect from '../../components/base/SmokeEffect';
import { mensShirts, womensShirts, accessories } from '../../mocks/products';

export default function ShopPage() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  
  const allProducts = [...mensShirts, ...womensShirts, ...accessories];
  
  const filteredProducts = selectedCategory === 'All' 
    ? allProducts 
    : allProducts.filter(p => p.category.includes(selectedCategory));

  const categories = ['All', 'Men\'s Shirts', 'Women\'s Shirts', 'Hats', 'Cases', 'Decals'];

  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden">
      <SmokeEffect />
      <Navbar />

      <section className="relative pt-28 sm:pt-32 pb-16 sm:pb-20 md:pb-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h1 className="font-orbitron text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-neon-purple to-neon-pink mb-3 sm:mb-4 px-4">
              Shop All Products
            </h1>
            <p className="font-rajdhani text-base sm:text-lg md:text-xl text-gray-300 px-4">
              Browse our complete collection of vape accessories and apparel
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-8 sm:mb-10 md:mb-12 px-2">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full font-rajdhani font-bold text-xs sm:text-sm transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-gradient-to-r from-neon-purple to-neon-pink shadow-lg shadow-neon-purple/50'
                    : 'bg-gray-800 hover:bg-gray-700 border border-neon-purple/30'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8" data-product-shop>
            {filteredProducts.map((product) => (
              <div
                key={product.id}
                className="group bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-neon-purple/30 hover:border-neon-purple hover:shadow-2xl hover:shadow-neon-purple/50 transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <div className="relative w-full h-64 sm:h-72 md:h-80 overflow-hidden bg-gray-800">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="p-4 sm:p-6">
                  <p className="text-neon-pink font-rajdhani text-xs sm:text-sm font-semibold mb-2">
                    {product.category}
                  </p>
                  <h3 className="font-orbitron text-base sm:text-lg font-bold text-white mb-3">
                    {product.name}
                  </h3>
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-teko text-2xl sm:text-3xl font-bold text-neon-purple">
                      ${product.price}
                    </span>
                    <button className="px-3 sm:px-4 py-2 bg-gradient-to-r from-neon-purple to-neon-pink rounded-lg font-rajdhani font-bold text-xs sm:text-sm hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer">
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
